/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getProfiles.defs'
export { main as default } from './getProfiles.defs'
